import { render, staticRenderFns } from "./ModelingOptionsDialog.vue?vue&type=template&id=481fa940&scoped=true&"
import script from "./ModelingOptionsDialog.vue?vue&type=script&lang=js&"
export * from "./ModelingOptionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ModelingOptionsDialog.vue?vue&type=style&index=0&id=481fa940&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481fa940",
  null
  
)

export default component.exports